export const timeConverter = (year, month, day) => {
    const dateString = year + "-" + month + "-" + day;
    return new Date(dateString);
}


